import script from "./BuyGoodsForOutOfHours.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyGoodsForOutOfHours.vue?vue&type=script&setup=true&lang=js"

import "./BuyGoodsForOutOfHours.vue?vue&type=style&index=0&id=057f4415&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-057f4415"]])

export default __exports__